import { Component, OnInit } from '@angular/core'
import { AuthService, GlobalSettingsService } from '../../../../api/services'

@Component({
  selector: 'app-decryptconnection-strings',
  templateUrl: './decryptconnection-strings.component.html',
  styleUrls: ['./decryptconnection-strings.component.css'],
})
export class DecryptconnectionStringsComponent implements OnInit {
  myConnectionStrings: string = ''
    constructor(private globalsettingservice: GlobalSettingsService, private authService: AuthService) {}

  ngOnInit() {
    //this.globalsettingservice.globalSettingsFetch({}).subscribe(result => {
    //   this.myConnectionStrings = result;
      //})

      this.authService.authViewConnectionString().subscribe(result => {
          this.myConnectionStrings = result;
      });
  }
}
